import { MAG_DOOR_STATUS } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Submit from 'components/inputs/Submit'
import Warehouse from 'components/Warehouse'
import { v7 } from 'uuid'

const type = process.env.REACT_APP_TYPE

const Introduction = ({ id, header, next }) => {

  const { t } = useTranslation('slides')
  const { push } = useHistory()

  const desc = t(`openedMagDescArray.${type}`)

  return <>
    {header}
    <div className='slide__title center'>
      <div className='--secFont'>{t('weInviteYouInside')}</div>
      <div>{t(`watchYourMag.${type}`)}</div>
    </div>

    <div className='slide__warehouses --wider'>
      {[1, 2, 3].map(e => <div
        key={e}
        className={`warehouse${e === 1 ? ' --left' : e === 3 ? ' --right' : ''}`}>
        <Warehouse door={e === 2 ? MAG_DOOR_STATUS.opened : MAG_DOOR_STATUS.closed} />
      </div>)}
    </div>

    <div className='slide__desc'>
      {Array.isArray(desc)
        ? desc.map((d, i) => <div key={i}>{d}</div>)
        : desc}
    </div>

    <div className='slide__buttons'>
      <BackBtn
        text={t('reportProblem')}
        action={() => {
          push(`/chat/${v7()}?warehouseId=${id}`)
        }} />

      <Submit
        text={t('next')}
        action={next} />
    </div>

  </>
}

export default Introduction